module.exports = __webpack_public_path__ + "img/googleplay.7687933f.png";